import Image from 'next/image';
import { SVGProps } from 'react';
import {
  ArrowRightIcon,
  BriefcaseIcon,
  OfficeBuildingIcon,
} from '@heroicons/react/solid';
import { Button } from '@jove-frontend/uikit';
import { motion } from 'framer-motion';
import BlueSwoosh from '../../../assets/blue_swoosh.png';
import ELIllustration from '../../../assets/business-page/EL-illustration.jpg';
import PIIllustration from '../../../assets/business-page/PI-illustration.jpg';
import PLIllustration from '../../../assets/business-page/PL-illustration.jpg';
import PurpleSwoosh from '../../../assets/purple_swoosh.png';

export const InsuranceTypes = () => {
  return (
    <div className="flex-col">
      {/* Proffesional indemnity */}
      <div className="relative mb-14 flex flex-col-reverse justify-between overflow-hidden rounded-2xl bg-black/5 shadow-xl shadow-black/10 lg:flex-row">
        <motion.div
          className="w-full p-10 lg:w-1/2"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          <h3 className="mb-2 text-[2rem] text-black">
            Professional indemnity{' '}
            <span className="font-normal">Insurance</span>
          </h3>
          <p>
            This provides you financial protection from alleged negligence or
            failure to deliver a service as promised.
          </p>

          {/* <Button color="tertiary" className="mt-11 -ml-4 p-0">
            <span className="font-bold">Read the case study</span>{' '}
            <ArrowRightIcon className="ml-1 w-4" />
          </Button> */}
        </motion.div>

        <div className="relative z-10 flex w-full flex-shrink-0 overflow-hidden lg:w-1/3">
          <motion.div
            className="relative z-10 mr-auto mb-4 hidden items-start justify-between space-x-5 self-end rounded-lg bg-white px-4 py-3 shadow-xl shadow-black/10 lg:flex"
            initial={{ opacity: 0, x: 100, scale: 1 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0,
              transition: { duration: 0.5, delay: 0.1 },
            }}
            viewport={{ once: true }}
          >
            <div className="text-brand-secondary-new bg-brand-secondary-new/10 inline-block rounded-full p-3">
              <BriefcaseIcon className="w-8" />
            </div>

            <div>
              <h5 className="font-serif font-black">
                John <span className="font-normal">Miles</span>
              </h5>
              <p>Small/Medium Enterprise</p>
              <p className="text-sm font-bold">Cover: £1,000,000</p>
            </div>
          </motion.div>

          <Image
            src={BlueSwoosh}
            alt="swoosh"
            height={507}
            width={915}
            className="absolute -left-1/4 -bottom-1/2 z-0 m-0 block rotate-[190deg] lg:hidden"
          />

          <Image
            src={PIIllustration}
            alt="Professional indemnity"
            className="right-10 top-0 z-0 m-0 mt-10 ml-auto h-full w-auto rounded-2xl lg:absolute lg:mt-0"
            style={{ objectFit: 'cover' }}
          />
        </div>

        <Image
          src={BlueSwoosh}
          alt="swoosh"
          height={507}
          width={915}
          className="absolute -right-1/3 z-0 m-0 -mr-24 mt-2 hidden rotate-[208deg] lg:block"
        />
      </div>

      {/* Public liability */}
      <div className="relative mb-14 flex flex-col-reverse justify-between overflow-hidden rounded-2xl bg-black/5 shadow-xl shadow-black/10 lg:flex-row">
        <motion.div
          className="w-full p-10 lg:w-1/2"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          <h3 className="mb-2 text-[2rem] text-black">
            Public liability <span className="font-normal">Insurance</span>
          </h3>
          <p>
            Protects you from any injury to clients or third parties or damage
            to their property caused by you, or any alleged negligence.
          </p>

          {/* <Button color="tertiary" className="mt-11 -ml-4 p-0">
            <span className="font-bold">Read the case study</span>{' '}
            <ArrowRightIcon className="ml-1 w-4" />
          </Button> */}
        </motion.div>

        <div className="relative z-10 flex flex-shrink-0 overflow-hidden lg:w-1/3">
          <motion.div
            className="relative z-10 ml-auto mr-3 mb-4 hidden items-start justify-between space-x-5 self-end rounded-lg bg-white px-4 py-3 shadow-xl shadow-black/10 lg:flex"
            initial={{ opacity: 0, x: 100, scale: 1 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0,
              transition: { duration: 0.5, delay: 0.1 },
            }}
            viewport={{ once: true }}
          >
            <div className="text-brand-secondary-new bg-brand-secondary-new/10 inline-block rounded-full p-3">
              <ManFallingIcon className="w-8" />
            </div>

            <div>
              <h5 className="font-serif font-black">
                John <span className="font-normal">Miles</span>
              </h5>
              <p>Small/Medium Enterprise</p>
              <p className="text-sm font-bold">Cover: £2,000,000</p>
            </div>
          </motion.div>

          <Image
            src={BlueSwoosh}
            alt="swoosh"
            height={507}
            width={915}
            className="absolute -left-1/4 -bottom-1/2 z-0 m-0 block rotate-[190deg] lg:hidden"
          />

          <Image
            src={PLIllustration}
            alt="Public liability"
            className="left-0 top-0 z-0 m-0 mt-10 ml-auto h-full w-auto rounded-2xl lg:absolute lg:mt-0"
            style={{ objectFit: 'cover' }}
          />
        </div>

        <Image
          src={PurpleSwoosh}
          alt="swoosh"
          height={517}
          width={835}
          className="absolute -top-32 -right-1/3 z-0 m-0 mr-10 hidden rotate-[23deg] lg:block"
        />
      </div>

      {/* Employer liability   */}
      <div className="relative mb-14 flex flex-col-reverse justify-between overflow-hidden rounded-2xl bg-black/5 shadow-xl shadow-black/10 lg:flex-row">
        <motion.div
          className="w-full p-10 lg:w-1/2"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          <h3 className="mb-2 text-[2rem] text-black">
            Employer liability <span className="font-normal">Insurance</span>
          </h3>
          <p>
            Covers you when you have staff and they are injured in the course of
            business for which you are alleged negligent.
          </p>

          {/* <Button color="tertiary" className="mt-11 -ml-4 p-0">
            <span className="font-bold">Read the case study</span>{' '}
            <ArrowRightIcon className="ml-1 w-4" />
          </Button> */}
        </motion.div>

        <div className="relative z-10 flex flex-shrink-0 overflow-hidden lg:w-1/3">
          <motion.div
            className="relative z-10 mr-auto mb-4 hidden items-start justify-between space-x-5 self-end rounded-lg bg-white px-4 py-3 shadow-xl shadow-black/10 lg:flex"
            initial={{ opacity: 0, x: 100, scale: 1 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0,
              transition: { duration: 0.5, delay: 0.1 },
            }}
            viewport={{ once: true }}
          >
            <div className="text-brand-secondary-new bg-brand-secondary-new/10 inline-block rounded-full p-3">
              <OfficeBuildingIcon className="w-8" />
            </div>

            <div>
              <h5 className="font-serif font-black">
                John <span className="font-normal">Miles</span>
              </h5>
              <p>Small/Medium Enterprise</p>
              <p className="text-sm font-bold">Cover: £1,000,000</p>
            </div>
          </motion.div>

          <Image
            src={BlueSwoosh}
            alt="swoosh"
            height={507}
            width={915}
            className="absolute -left-1/4 -bottom-1/2 z-0 m-0 block rotate-[190deg] lg:hidden"
          />

          <Image
            src={ELIllustration}
            alt="Employer liability"
            className="right-4 top-0 z-0 m-0 mt-10 ml-auto h-full w-auto rounded-2xl lg:absolute lg:mt-0"
            style={{ objectFit: 'cover' }}
          />
        </div>

        <Image
          src={BlueSwoosh}
          alt="swoosh"
          height={507}
          width={915}
          className="absolute -right-1/3 -top-1/2 z-0 m-0 -mr-14 -mt-10 rotate-[217deg]"
        />
      </div>

      {/* Public liability */}
      <div className="relative mb-14 flex flex-col-reverse justify-between overflow-hidden rounded-2xl bg-black/5 shadow-xl shadow-black/10 lg:flex-row">
        <motion.div
          className="w-full p-10 lg:w-1/2"
          initial={{ opacity: 0, y: 100, scale: 1 }}
          whileInView={{
            opacity: 1,
            scale: 1,
            y: 0,
            transition: { duration: 0.5, delay: 0.1 },
          }}
          viewport={{ once: true }}
        >
          <h3 className="mb-2 text-[2rem] text-black">
            Personal accidents <span className="font-normal">Insurance</span>
          </h3>
          <p>
            Will pay a benefit if someone working for the business suffers an
            accident resulting in loss of sight, hearing, speech or a limb,
            death or leaving them disabled and permanently unable to work.
          </p>

          {/* <Button color="tertiary" className="mt-11 -ml-4 p-0">
            <span className="font-bold">Read the case study</span>{' '}
            <ArrowRightIcon className="ml-1 w-4" />
          </Button> */}
        </motion.div>

        <div className="relative z-10 flex flex-shrink-0 overflow-hidden lg:w-1/3">
          <motion.div
            className="relative z-10 ml-auto mr-3 mb-4 hidden items-start justify-between space-x-5 self-end rounded-lg bg-white px-4 py-3 shadow-xl shadow-black/10 lg:flex"
            initial={{ opacity: 0, x: 100, scale: 1 }}
            whileInView={{
              opacity: 1,
              scale: 1,
              x: 0,
              transition: { duration: 0.5, delay: 0.1 },
            }}
            viewport={{ once: true }}
          >
            <div className="text-brand-secondary-new bg-brand-secondary-new/10 inline-block rounded-full p-3">
              <HeartPulseIcon className="w-8" />
            </div>

            <div>
              <h5 className="font-serif font-black">
                John <span className="font-normal">Miles</span>
              </h5>
              <p>Small/Medium Enterprise</p>
              <p className="text-sm font-bold">Cover: £2,000,000</p>
            </div>
          </motion.div>

          <Image
            src={BlueSwoosh}
            alt="swoosh"
            height={507}
            width={915}
            className="absolute -left-1/4 -bottom-1/2 z-0 m-0 block rotate-[190deg] lg:hidden"
          />

          <Image
            src={PIIllustration}
            alt="Personal accidents"
            className="left-20 top-0 z-0 m-0 mt-10 ml-auto h-full w-auto rounded-2xl lg:absolute lg:mt-0"
            style={{ objectFit: 'cover' }}
          />
        </div>

        <Image
          src={PurpleSwoosh}
          alt="swoosh"
          height={517}
          width={835}
          className="absolute -top-full -right-1/4 z-0 m-0 -mt-10 -mr-4 -rotate-[180deg]"
        />
      </div>
    </div>
  );
};

const ManFallingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_631_19814)">
      <path
        d="M7.62986 3.29439C7.62986 4.86189 6.35924 6.13127 4.79049 6.13127C3.22299 6.13127 1.95361 4.86189 1.95361 3.29439C1.95361 1.72564 3.22299 0.455017 4.79049 0.455017C6.35924 0.455642 7.62986 1.72627 7.62986 3.29439Z"
        fill="currentColor"
      />
      <path
        d="M20.0227 11.4369C19.9483 11.3406 19.8896 11.2906 19.8896 11.2906C17.6446 9.20063 15.0077 9.20688 13.0021 9.68688C11.6739 9.11938 10.6427 8.41251 9.87457 7.75813C11.5308 6.65126 12.2414 5.00563 12.6321 3.64813C12.6514 3.57876 12.7064 3.36876 12.7064 3.36876C12.7564 3.08938 12.8552 2.10626 11.8714 1.76001C10.7189 1.35501 10.3421 2.61688 10.3421 2.61688C10.3152 2.71438 10.2983 2.81251 10.2689 2.90376C9.70145 4.77501 8.74082 5.72251 7.01207 6.13501C3.31707 7.02001 1.72145 8.92313 1.07582 10.0656C1.02957 10.15 0.730199 10.6444 0.632699 11.0888C0.553324 11.4406 0.544574 12.2888 1.42957 12.6388C2.3327 12.9963 2.78457 12.2863 2.93207 11.9781C2.9702 11.8975 3.03707 11.74 3.09082 11.63C3.2827 11.2469 3.84145 10.37 5.21957 9.61438C6.22645 10.8131 8.05145 12.5931 10.8333 13.8969C11.9796 14.6488 13.9546 16.2306 14.1221 18.2925C14.1221 18.2925 14.1602 18.5194 14.1846 18.5894C14.3152 18.9838 14.6677 19.6406 15.5433 19.5344C16.2771 19.445 16.5258 18.9225 16.6077 18.5138C16.6383 18.3475 16.6527 18.2 16.6514 18.1075C16.4452 15.5681 14.8071 13.6619 13.3496 12.4494C14.8108 12.0513 16.7446 11.9538 18.2739 13.3856C18.2739 13.3856 18.3827 13.4588 18.4033 13.4725C18.7121 13.6838 19.4677 14.0619 20.0877 13.2738C20.6989 12.4975 20.2633 11.7494 20.0227 11.4369Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_631_19814">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

const HeartPulseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.36 6.66982C25.8942 5.19068 23.9608 4.2656 21.8893 4.05225C19.8179 3.83891 17.7365 4.35049 16 5.49982C14.2653 4.35572 12.1882 3.84714 10.1211 4.0604C8.0541 4.27367 6.12455 5.19564 4.66001 6.66982C3.27375 8.08015 2.37539 9.89723 2.09648 11.855C1.81757 13.8128 2.17274 15.8085 3.11001 17.5498C3.48673 18.2207 3.95825 18.8336 4.51001 19.3698L11 25.9198C11.6506 26.5744 12.4242 27.0939 13.2762 27.4484C14.1283 27.8029 15.0421 27.9854 15.965 27.9854C16.8879 27.9854 17.8017 27.8029 18.6538 27.4484C19.5059 27.0939 20.2794 26.5744 20.93 25.9198L27.47 19.3198C28.0151 18.7876 28.483 18.1818 28.86 17.5198C29.8091 15.7902 30.1757 13.8009 29.9055 11.8466C29.6353 9.89232 28.7427 8.07706 27.36 6.66982ZM23 15.9998H21.07C20.9053 16.0007 20.7434 16.0422 20.5986 16.1207C20.4538 16.1992 20.3306 16.3123 20.24 16.4498L18.83 18.5498C18.7385 18.6859 18.615 18.7975 18.4702 18.8746C18.3255 18.9517 18.164 18.9921 18 18.9921C17.836 18.9921 17.6745 18.9517 17.5298 18.8746C17.385 18.7975 17.2615 18.6859 17.17 18.5498L14 13.7998L13.43 14.6598C13.1562 15.0721 12.7846 15.4101 12.3484 15.644C11.9122 15.8778 11.4249 16 10.93 15.9998H9.00001C8.73479 15.9998 8.48044 15.8945 8.2929 15.7069C8.10536 15.5194 8.00001 15.265 8.00001 14.9998C8.00001 14.7346 8.10536 14.4803 8.2929 14.2927C8.48044 14.1052 8.73479 13.9998 9.00001 13.9998H10.93C11.0947 13.999 11.2567 13.9574 11.4015 13.8789C11.5463 13.8004 11.6694 13.6874 11.76 13.5498L13.17 11.4498C13.2615 11.3137 13.385 11.2022 13.5298 11.125C13.6745 11.0479 13.836 11.0076 14 11.0076C14.164 11.0076 14.3255 11.0479 14.4702 11.125C14.615 11.2022 14.7385 11.3137 14.83 11.4498L18 16.1998L18.57 15.3398C18.8439 14.9276 19.2154 14.5895 19.6516 14.3557C20.0878 14.1219 20.5751 13.9996 21.07 13.9998H23C23.2652 13.9998 23.5196 14.1052 23.7071 14.2927C23.8947 14.4803 24 14.7346 24 14.9998C24 15.265 23.8947 15.5194 23.7071 15.7069C23.5196 15.8945 23.2652 15.9998 23 15.9998Z"
      fill="currentColor"
    />
  </svg>
);
